


/**
* The type that a chat message is
*/
export enum ChatType{
    /**
    * The mentee will be able to see these chat messages
    */
    Public = 0,
    /**
    * Mentor and Observers will be able to see these chat messages
    */
    Internal = 1,
    /**
    * Only the To and From users will be able to see these chat messages
    */
    Private = 2,
    /**
    * Only the Mentee and Mentor will be able to see these chat messages
    */
    Mentee = 4
}

